import { z } from 'zod';
import { WithId } from './WithId';
import { JawScanCreateSchema, JawScanResponse, JawScanSummaryResponse } from './jawScan';

export const Status = {
  scanned: 'Scanned',
  segmented: 'Segmented',
  corrected: 'Corrected',
  /**
   * Production has the printable models — an admin downloaded them from the panel.
   * The only stage not derived from a row in the database; the models leave the
   * system as a file, so the download itself is what gets recorded.
   */
  printing: 'Printing',
  braces_created: 'Braces Created',
  printed: 'Printed',
  empty: 'Empty',
} as const;

export type Status = (typeof Status)[keyof typeof Status] | null;

export const JawsScanCreateSchema = z.object({
  upperJawData: JawScanCreateSchema,
  lowerJawData: JawScanCreateSchema,
  scanDate: z.string().date(),
  note: z.string().nullable().optional(),
  patientId: z.string().nonempty('Clinic ID is required'),
});

export type JawsScanCreate = z.infer<typeof JawsScanCreateSchema>;

export type JawsScanResponse = WithId & {
  patientId: string;
  scanDate: string;
  note?: string | null;
  upperJaw: JawScanResponse;
  lowerJaw: JawScanResponse;
  jawsSegmentationId?: string | null;
  jawsCorrectionIds: string[];
  jawsBracesIds: string[];
  status: Status;
};

export type JawsScanSummaryResponse = WithId & {
  patientId: string;
  scanDate: string;
  note?: string | null;
  upperJaw: JawScanSummaryResponse;
  lowerJaw: JawScanSummaryResponse;
  jawsSegmentationId?: string | null;
  jawsCorrectionIds: string[];
  jawsBracesIds: string[];
  status: Status;
};

export const JawsScanUpdateSchema = z.object({
  note: z.string().max(500).nullable().optional(),
  scanDate: z.string().date().optional(),
});

export type JawsScanUpdate = z.infer<typeof JawsScanUpdateSchema>;
